import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { isNullOrUndefined } from 'src/app/services/utils';
import { environment } from '../../environments/environment';
import { COMMON_CONSTANTS } from '../common/core/common.constants';
import { EnvironmentDetailsService } from './environment-details.service';
import { HelperUtilityService } from './helper-utility.service';
import { HttpCacheService } from './http-cache.service';
import { AuthHttpService } from './http-wrapper.service';

@Injectable({
  providedIn: 'root',
})
export class TransactionHistoryService {

  constructor(private httpClient: AuthHttpService,
              private _envSvc: EnvironmentDetailsService, private _helperUtilSvc: HelperUtilityService,  private _cacheSvc: HttpCacheService) {
    this.authToken = !isNullOrUndefined(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY)) ?
      COMMON_CONSTANTS.HEADER_PROPERTIES.BEARER_KEY + this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY) : '';
    this.orgID =  this._helperUtilSvc.getOrgID();
   }
  authToken: any;
  orgID: any;
  fromStrategicPortIn = new BehaviorSubject(null);

  setHeaders() {

    return {
      headers: new HttpHeaders(
        {
          'Accept': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
          'Content-Type': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
          'Cache-Control': COMMON_CONSTANTS.HEADER_PROPERTIES.NO_CACHE,
          // 'Authorization': this.authToken,
          'B2b-Client': this._helperUtilSvc.getClientId(),
          'B2b-Org': this.orgID,
          'authType': this._helperUtilSvc.getAuthType(),
          'transactionID': this._helperUtilSvc.getTransactionID(),
          'authToken':this._helperUtilSvc.getAuthToken(),
        },
      ),
    };
  }

  getTransactionHistory(orderType,pageSize , dateRange, pageNumber, mobileNumber?, billingAccounts?,submittedBy?): Observable<any> {
    if(isNullOrUndefined(mobileNumber)) {
      mobileNumber = '';
    }
    if(isNullOrUndefined(billingAccounts)) {
      billingAccounts = '';
    }
    if(isNullOrUndefined(orderType)){
      orderType='';
    }
    if(isNullOrUndefined(submittedBy)){
      submittedBy='';
    }
    const httpOptions = this.setHeaders();
    const reqBody = {
        "mobileNumbers": mobileNumber,
        "dateRangeLimit": dateRange,
        "billingAccounts": billingAccounts,
        "submittedBy": submittedBy,
        "page": pageNumber,
        "pageSize": pageSize,
        "orderType": orderType,
      };
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_TRANSACTION_HISTORY);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_TRANSACTION_HISTORY, reqBody, httpOptions);
    }
  }
  downloadTerms(docId,content): Observable<any>{
    const httpOptions = this.setHeaders();

    const accountOrderID = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCOUNT_ORDER_ID);
    const requestBody = {
      "documentId": docId,
      "docReturnType": content,
      "transactionId": accountOrderID
    };
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_DOWNLOAD_TERMS);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_DOWNLOAD_TERMS, requestBody, httpOptions);
    }
  }
  setHeadersForDownloadTerms(){
    this.authToken = !isNullOrUndefined(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY)) ?
      COMMON_CONSTANTS.HEADER_PROPERTIES.BEARER_KEY + this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY) : '';
    return {
      headers: new HttpHeaders(
        {
          'Accept': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
          'Content-Type': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
          'Cache-Control': COMMON_CONSTANTS.HEADER_PROPERTIES.NO_CACHE,
          'B2b-Client': COMMON_CONSTANTS.HEADER_PROPERTIES.B2B_CLIENT_ID_TFB_AM_APP,
          'B2b-Org': this._helperUtilSvc.getOrgID(),
          'transactionID':  this._helperUtilSvc.getTransactionID(),
          'authToken':this._helperUtilSvc.getAuthToken(),
        }
      )
    };
  }
  getViewLineHistoryTransactions(orderType, billingAccounts, pageSize , dateRange, pageNumber, mobileNumber?,submittedBy?): Observable<any> {
    if(isNullOrUndefined(mobileNumber)) {
      mobileNumber = '';
    }
    if(isNullOrUndefined(submittedBy)){
      submittedBy='';
    }
    const httpOptions = this.setHeaders();
      const reqBody = {
        "mobileNumbers": mobileNumber,
        "dateRangeLimit": dateRange,
        "billingAccounts": billingAccounts,
        "submittedBy": submittedBy,
        "page": pageNumber,
        "pageSize": pageSize,
        "orderType": orderType,
      };
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_TRANSACTION_HISTORY);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_TRANSACTION_HISTORY, reqBody, httpOptions);
    }
  }

  getTransactionHistoryDetails(pageSize, pageNumber): Observable<any> {
    const acountOrderID = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCOUNT_ORDER_ID);
    const httpOptions = {
      ...this.setHeaders(),
      params: {
        transactionId: acountOrderID,
        pageNumber: pageNumber,
        pageSize: pageSize
      }
    }
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_TRANSACTION_HISTORY_DETAILS);
    } else {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_TRANSACTION_HISTORY_DETAILS, httpOptions);
    }
  }

  getPaymentDetails(billingAccount): Observable<any> {
    const httpOptions = {
      ...this.setHeaders(),
      headers: {
        'activity-id': this._helperUtilSvc.getTransactionID() || ''
      },
      params: {
        'transactionId': this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCOUNT_ORDER_ID) || ''
      }

    }
    const reqBody = {
      "billingAccount": billingAccount,
    };
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_PAYMENT_DETAILS);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_PAYMENT_DETAILS,reqBody, httpOptions);
    }
  }
  checkResetEngagement(request){
    const httpOptions = this.setHeaders();
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_RESET_ENGAGEMENT);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_RESET_ENGAGEMENT, request, httpOptions);
    }
  }
}
